interface PersonFocusedWithCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonFocusedWithCheckmarkSVG = ({
  color,
  style,
}: PersonFocusedWithCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="53"
    viewBox="0 0 44 53"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17619)">
      <path
        d="M38.906 29.3495C39.4588 29.7315 39.9425 30.0933 40.3473 30.425C41.0581 31.008 41.6504 31.7116 42.1341 32.4955C43.0325 33.953 43.4471 35.6617 43.4471 37.3804V44.8987H29.3893"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.094 29.3495C4.55103 29.7315 4.05743 30.0933 3.65267 30.425C2.94188 31.008 2.34955 31.7116 1.86582 32.4955C0.967454 33.953 0.552826 35.6617 0.552826 37.3804V44.8987H14.6107"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.0049 27.872C27.9697 27.872 32.805 21.7564 32.805 14.2124C32.805 6.66842 27.9697 0.552811 22.0049 0.552811C16.0402 0.552811 11.2048 6.66842 11.2048 14.2124C11.2048 21.7564 16.0402 27.872 22.0049 27.872Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.6302 0.562866H36.7539V5.77944"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.3697 27.872H7.24612V22.6554"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.7539 22.6554V27.872H31.6302"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.24612 5.77944V0.562866H12.3697"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.7539 10.1329V18.4138"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.24612 10.1329V18.4138"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.1969 46.6376C30.135 42.591 27.6735 38.5363 23.699 37.5812C19.7245 36.6262 15.742 39.1323 14.804 43.1789C13.8659 47.2256 16.3274 51.2802 20.3019 52.2353C24.2764 53.1904 28.2589 50.6842 29.1969 46.6376Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.3424 44.2253L21.4126 47.3512L26.2203 42.4663"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17619">
        <rect width="44" height="53" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonFocusedWithCheckmarkSVG;
